export default defineNuxtPlugin(() => {
  if (import.meta.env.VITEST) return;

  const { env, version } = useRuntimeConfig().public.deploy;

  // oxlint-disable-next-line no-console
  console.log(
    `%c centro-de-control %c ${env} %c ${version} `,
    'background:#1e3a5f;color:#fff;padding:2px 6px;border-radius:3px 0 0 3px;font-weight:bold',
    'background:#2d7d46;color:#fff;padding:2px 6px;font-weight:bold',
    'background:#444;color:#fff;padding:2px 6px;border-radius:0 3px 3px 0',
  );
});
